import * as React from "react";
const SvgArrowDropDownOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="m7 10 5 5 5-5H7z" />
  </svg>
);
export default SvgArrowDropDownOutlined;
